import * as React from 'react';
import { CommentEditState } from '../../../Stores/CommentEditState';
// import AudioRecorder, { AudioRecorderUseMode } from '../../../_components/AudioRecorder';
import { AudioRecorderUseMode } from '../../../_components/AudioRecorder/AbstractAudioView';
import { AudioRecorder } from '../../../_components/AudioRecorder/AudioRecorder';
import { Recorder } from '../../../_components/AudioRecorder/Recorder';
import { colors } from '../../../styles/colors';
import { AddButton } from './AddButton';
import {
    audioRecorderContainerStyle,
    newCommentAudioRecorderStyle,
    newCommentButtonContainerStyle,
    newCommentManageButtonContainerStyle,
    newCommentProgressBackgroundStyle,
    newCommentProgressBarStyle,
    newCommentProgressHandleStyle,
    newCommentProgressLabelStyle,
    newCommentProgressTrackStyle,
    placeholderTextStyle,
    progressHandleHiddenStyle
} from './AudioStyles';
import { ClearButton } from './ClearButton';
import { createPauseButton } from './PauseButton';
import { createStartButton } from './StartButton';
import { createStopButton } from './StopButton';

const BUTTON_SIZE = 34;

const StartButtonComponent = createStartButton(BUTTON_SIZE);
const StopButtonComponent = createStopButton(BUTTON_SIZE);
const PauseButtonComponent = createPauseButton(BUTTON_SIZE);

interface IProps {
    onRecordingComplete(): void;
    recorderUseMode: number;
    commentEditState: CommentEditState;
}

export const NewCommentAudioRecorder: React.SFC<IProps> = ({
        commentEditState,
        recorderUseMode,
        onRecordingComplete
    }) => {
    return (
        <div>
            <Recorder
                commentEditState={commentEditState}
                onUserConfirmedRecording={(blob: any, uri: any, lengthInMs: any) => {
                    commentEditState.setAudio(blob, lengthInMs);
                    onRecordingComplete();
                }}
            />
        </div>
); };



// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/Audio/NewCommentAudioRecorder.tsx